export default __webpack_public_path__ + "static/media/sass-logo.58e61bc9.png";